import gql from "graphql-tag";

export const CREATE_REMINDER = gql`
  mutation AddReminder($data: ReminderDataInput) {
    addReminder(data: $data) {
      id
    }
  }
`;

export const UPDATE_REMINDER = gql`
  mutation updateReminder(
    $data: ReminderDataInput
    $where: ReminderWhereInput
  ) {
    updateReminder(data: $data, where: $where) {
      id
    }
  }
`;

export const DELETE_REMINDER = gql`
  mutation deleteReminder($where: ReminderWhereInput) {
    deleteReminder(where: $where) {
      id
    }
  }
`;

const reminders = { CREATE_REMINDER, UPDATE_REMINDER, DELETE_REMINDER };

export default reminders;
